// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_3tGhV","clearfix":"reset_clearfix_Rj9Si"};